import { render } from "./EmailModal.vue?vue&type=template&id=15824c6d&scoped=true&ts=true"
import script from "./EmailModal.vue?vue&type=script&lang=ts"
export * from "./EmailModal.vue?vue&type=script&lang=ts"

import "./EmailModal.vue?vue&type=style&index=0&id=15824c6d&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15824c6d"]])

export default __exports__